<template>
    <div element-loading-spinner="qc-spinner" :loading="loadingRevenueData" v-loading="loadingRevenueData" id="canvasContainer">
        <canvas id="revenueGraph"></canvas>
    </div>
</template>

<script>
import Chart from "chart.js";
import { mapGetters, mapState } from "vuex";
import moment from 'moment'
import { utils, writeFile } from 'xlsx'
export default {
    name: "revenue-graph",
    components: {
        Chart,
    },
    data() {
        return {
            loadingRevenueData: false,
            responsive: true,
            sidebarStore: false,
            counter: null,
            chartName: "",
            chart: "",
            chartData: {
                labels: [],
                datasets: [
                    {
                        label: 'Revenue',
                        fill: false,
                        borderColor: '#3ca5aa',
                        pointBorderColor: '#2e8084',
                        pointBackgroundColor: "#FEFEFE",
                        borderWidth: 2,
                        tension: 0.3,
                        data: [],
                        pointRadius: 4,
                    }
                ]
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                    yAxes: [{
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
                        ticks: {
                            beginAtZero: true,
                            precision: 0,
                            suggestedMax: 5,
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        }
                    }]
                },
                legend: {
                    display: false
                },
            }
        };
    },
    async mounted() {
        this.$store.state.revenueGraphChartName = "Monthly (12)"
        this.chartName = this.$store.state.revenueGraphChartName
    },
    beforeDestroy() {
        this.$store.state.revenueGraphChartName = ""
    },
    methods: {
        downloadData() {
            let downloadData = {
                date: [],
                revenueSpend: [],
            }
            for (let i = 0; i < this.chartData.datasets[0].data.length; i++) {
                downloadData.date.push(this.chartData.labels[i])
                downloadData.revenueSpend.push("£" + this.chartData.datasets[0].data[i].toFixed(2))
            }
            const data = downloadData.date.map((date, i) => ({
                Date: date,
                "Revenue Spend": downloadData.revenueSpend[i]
            }));
            const worksheet = utils.json_to_sheet(data);
            const workbook = utils.book_new()
            utils.book_append_sheet(workbook, worksheet, "Revenue Data")
            writeFile(workbook, "Revenue_Data.xlsx")
        },
        async setRevenueData() {
            if(this.loadingRevenueData) return;
            this.loadingRevenueData = true
            this.counter = this.chartName.substring(0, this.chartName.length - 1).slice(-2)
            this.chartData.labels = []
            this.chartData.datasets[0].data = []
            await this.$api.getRevenueData(this.counter, this.$store.state.selectedApplicationTemplateIds)
                .then(response => {
                    this.revenueData = response.data
                    for (let i = 0; i < this.revenueData.currentPeriod.length; i++) {
                        if (this.counter == 52) {
                            var s = this.revenueData.currentPeriod[i].date.split(" ")
                            this.chartData.labels.push(moment().day("Monday").week(s[0]).format("Do MMM"))
                        } else {
                            this.chartData.labels.push(this.revenueData.currentPeriod[i].date)
                        }
                        this.chartData.datasets[0].data.push(this.revenueData.currentPeriod[i].count)
                    }
                }).catch(error => {
                    console.log("ERROR", error)
                })
            if (this.chart != "") {
                this.loadingRevenueData = false
                this.chart.update()
            } else {
                this.chartConstructor();
            }
        },
        chartConstructor() {
            const chartElement = document.getElementById("revenueGraph");
            this.chart = new Chart(chartElement, {
                type: "line",
                data: this.chartData,
                options: this.chartOptions,
            });
            revenueGraph.style.height = null
            this.loadingRevenueData = false
        },
    },
    computed: {
        ...mapState(["revenueGraphChartName", "downloadRevenueSheet"]),
        ...mapGetters({
            newRevenueGraphChartName: "getRevenueGraphChartName",
            newDownloadRevenueSheet: "getDownloadRevenueSheet"
        }),
    },
    watch: {
        newRevenueGraphChartName: async function (val) {
            this.chartName = val
            this.setRevenueData()
        },
        newDownloadRevenueSheet: function(val) {
            if(val == true) {
                this.downloadData()
            }
            this.$store.state.downloadRevenueSheet = false;
        },
        '$store.state.selectedApplicationTemplateIds': {
          deep: true,
          handler() {
            this.setRevenueData()
          }
        }
    },
};

</script>
